// Homepage "Latest news" entries — KEEP THIS CURRENT (see CLAUDE.md).
// Whenever a user-facing feature ships or changes, add an entry here in the
// same change, and prune entries that no longer describe the site. The
// homepage shows the three most recent by date; entries without a date sort
// oldest and their card shows no date chip.
//
// Shape: { id, date ("YYYY-MM-DD", optional), title, body, link?: {label, to} }
// `link.to` must be a real path in src/components/Routes/RouteHandler.js.
export const news = [
  {
    id: "liquid-glass-redesign",
    date: "2026-10-01",
    title: "A fresh new look for Node",
    body: "Every page has been redesigned — cleaner layouts, easier-to-scan tables, and a new Liquid Glass style with translucent panels inspired by Apple's latest design. Prefer solid panels, or want dark mode? Click the sun icon in the top-right corner to pick Light, Dark, or Auto and Liquid Glass or Classic. You can also press Ctrl+K (⌘K on a Mac) on any page to jump straight to another one.",
    link: { label: "How to change the look", to: "/help?a=dark-mode" },
  },
  {
    id: "toolbox-talks",
    date: "2026-09-15",
    title: "Safety toolbox talks are now on Node",
    body: "You can now watch the safety team's toolbox talk videos right here on Node — the same talks as in the mobile app, newest first. Find them in the menu under Safety → Toolbox Talks, or add the Toolbox Talks widget to your homepage to see when a new one is posted.",
    link: { label: "Watch Toolbox Talks", to: "/safety/toolbox-talks" },
  },
  {
    id: "forms-hub",
    date: "2026-09-03",
    title: "All forms in one place",
    body: "The menu just got simpler: every form on the site now lives under Forms → Submit a Form — RFQs, service requests, the Remodel Form, Order Problems, Caught in the Act, and feature requests. And My Submissions, right below it, lists everything you've sent in across all of them with a status on each. Your old favorites and links still work.",
    link: { label: "Open Submit a Form", to: "/forms" },
  },
  {
    id: "remodel-form",
    date: "2026-09-03",
    title: "New Remodel Form for remodel leads",
    body: "Talking to a homeowner about a remodel? Send the lead in with the new Remodel Form (Forms → Submit a Form) — pick what they want quoted (windows, entry doors, patio doors), and the lead is emailed straight to the remodel team with a printable PDF attached. You get a copy too.",
    link: { label: "Open the Remodel Form", to: "/forms/remodel" },
  },
  {
    id: "chat-on-web",
    date: "2026-08-26",
    title: "Chat is now on the website",
    body: "The mobile app's chat has come to Node. Direct message a coworker, react to messages with emoji, share photos, and keep up with your branch channel and the company-wide channel — everything stays in sync with chat in the mobile app. Open it from the chat icon in the top-right corner of any page (it shows a badge when you have unread messages), or add the Messages widget to your homepage.",
    link: { label: "Open Messages", to: "/messages" },
  },
  {
    id: "menu-overhaul",
    date: "2026-08-26",
    title: "Finding pages just got easier",
    body: "The navigation menu has been regrouped by what you're doing — Windows & Doors, Sales & Leads, Everyday Tools, and more — with no more menus-inside-menus, plus a “Find a page…” box at the top that filters every page you can open as you type. You can also search every page from the top bar on any page.",
  },
  {
    id: "feedback-retired",
    date: "2026-08-26",
    title: "The Feedback page has been retired",
    body: "The old Feedback ratings page is gone. To suggest an improvement or report something that isn't working, use Request a Feature (Forms → Submit a Form) — it goes straight to the team that builds Node.",
    link: { label: "Request a feature", to: "/forms/feature-request" },
  },
  {
    id: "window-service-requests",
    date: "2026-08-21",
    title: "Window & door service requests move into Node",
    body: "You can now submit window/door service requests right here instead of the old external form. Track each one under My Service Requests — you'll see the shop's progress, get notified on every status change, and can message the shop directly on the request.",
    link: { label: "Submit a service request", to: "/windowdoor/service-request" },
  },
  {
    id: "anonymous-order-problems",
    date: "2026-08-20",
    title: "Order Problem reports are now anonymous",
    body: "Reporting an order problem no longer attaches your name — the report lands on the Order Problems dashboard with no submitter attached. Because it's anonymous, nobody can reply to you, so add how to reach you in the comments if you need an answer back.",
    link: { label: "Report an Order Problem", to: "/forms/order-problem" },
  },
  {
    id: "home-widgets",
    date: "2026-08-06",
    title: "Widgets on your homepage",
    body: "Add live, tile-sized summaries of the pages you use — weather, lead times, web lead counts, spec sheets, and more. Click Edit next to My widgets on the home page to pick yours.",
  },
  {
    id: "homepage-refresh",
    date: "2026-08-06",
    title: "A more personal homepage",
    body: "The homepage now greets you by name, and Quick access is yours to build: everyone gets File Share, Calendar, and Help & FAQ, and any page you star gets added as a card next to them.",
  },
  {
    id: "notifications-return",
    date: "2026-08-06",
    title: "Notifications are back",
    body: "The bell is back in the header, and new notifications also show up right on the homepage. Assignments and request updates that involve you will land there.",
  },
  {
    id: "interior-door-configurator",
    title: "Interior Door Configurator",
    body: "Get real-time pricing of stock door packages using the Interior Door Configurator.",
    link: { label: "Try it", to: "/forms/new/rfq" },
  },
  {
    id: "sbcf-dashboard",
    title: "SBCF Dashboard",
    body: "Check quote and order status in real-time with the SBCF dashboard.",
    link: { label: "Open SBCF", to: "/sbcf" },
  },
];
